import { api } from "./client";
import type {
  AstralAutoGatherResponse,
  AstralGatherResponse,
  AstralRarity,
  AstralShop,
  AstralShopPurchaseResult,
  AstralState,
  QuickSellSettings,
} from "../types";

export const astralApi = {
  getState: () => api.get<AstralState>("/astral"),

  gather: (tier: number) => api.post<AstralGatherResponse>("/astral/gather", { tier }),

  autoGather: (gold_budget: number, sell_rarities: AstralRarity[]) =>
    api.post<AstralAutoGatherResponse>("/astral/auto-gather", { gold_budget, sell_rarities }),

  sell: (astral_id: number) =>
    api.post<AstralState & { sold_gold?: number; sold_star_dust?: number }>("/astral/sell", {
      astral_id,
    }),

  upgrade: (astral_id: number) => api.post<AstralState>("/astral/upgrade", { astral_id }),

  quickSell: (rarities?: AstralRarity[]) =>
    api.post<
      AstralState & {
        quick_sell?: { count: number; gold: number; star_dust: number; rarities: string[] };
      }
    >("/astral/quick-sell", rarities ? { rarities } : {}),

  updateQuickSellSettings: (settings: QuickSellSettings) =>
    api.put<AstralState>("/astral/quick-sell-settings", settings),

  equip: (astral_id: number, slot: number) =>
    api.post<AstralState>("/astral/equip", { astral_id, slot }),

  unequip: (slot: number) => api.post<AstralState>("/astral/unequip", { slot }),

  getShop: () => api.get<AstralShop>("/astral/shop"),

  purchase: (template_code: string) =>
    api.post<AstralShopPurchaseResult>("/astral/shop/purchase", { template_code }),
};
